import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { AgencyCard } from '../../Cards/AgencyCard';
import { AgenciesQuery } from '../../../graphql/graphql';
import { AgencyListContainer } from './styled';
import { BusinessItemsListPageWrapper } from '../../BusinessItemsListPage';
import { agenciesQuery } from '../../../api/queries';

interface AgenciesListProps {
  hasError: boolean;
}

export const AgenciesList: React.FC<AgenciesListProps> = ({ hasError }) => {
  const { t } = useTranslation();

  const title = t('pages.agencies.title');

  const { data, error, loading } = useQuery<AgenciesQuery>(agenciesQuery);
  return (
    <BusinessItemsListPageWrapper
      title={title}
      hasError={hasError || error}
      items={data?.agencies}
      loading={loading}
      CardComponent={AgencyCard}
      ListContainer={AgencyListContainer}
    />
  );
};
